import { render } from "./VersionGuard.vue?vue&type=template&id=f361f734&scoped=true&ts=true"
import script from "./VersionGuard.vue?vue&type=script&lang=ts"
export * from "./VersionGuard.vue?vue&type=script&lang=ts"

import "./VersionGuard.vue?vue&type=style&index=0&id=f361f734&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c14bfaf61e4aff3d2996531c89f90cfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f361f734"]])

export default __exports__